const adjustmentRoutes = [
  {
    path: 'adjustment-drafts',
    component: () =>
      import(
        /* webpackChunkName: "adjustment" */
        '@/view/pages/einvoice/adjustment/AdjustmentDrafts.vue'
      ),
    children: [
      {
        path: '/',
        name: 'adjustment-draft-list',
        component: () =>
          import(
            /* webpackChunkName: "adjustment" */
            '@/view/pages/einvoice/adjustment/DraftList.vue'
          ),
        meta: { title: 'Nháp hóa đơn điều chỉnh GTGT' },
      },
      {
        path: ':draftId',
        name: 'adjustment-draft-detail',
        component: () =>
          import(
            /* webpackChunkName: "adjustment" */
            '@/view/pages/einvoice/adjustment/DraftDetail.vue'
          ),
        meta: { title: 'Chi tiết nháp điều chỉnh GTGT' },
      },
    ],
  },
  {
    path: 'adjustment-wizard',
    name: 'adjustment-wizard',
    component: () =>
      import(
        /* webpackChunkName: "adjustment" */
        '@/view/pages/einvoice/adjustment/Wizard.vue'
      ),
    meta: { title: 'Tiến trình tạo điều chỉnh GTGT' },
  },
];

export default adjustmentRoutes;
